import React, { Component } from 'react';
import {
  Button, Icon, Row, Col, Popconfirm,
} from 'antd';
import isBackOffice from 'utils/appUtils';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import translate from 'app/translations';
import steps from '../AgentProfileSteps';
import AgentProfilePropType from '../AgentProfilePropType';

export class WizardNav extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  getStepDefaults(currentPage) {
    const {
      confirmHeading,
      confirmBody,
      forwardLabel,
      forwardLink,
      backLabel,
      backLink,
      isCallInProgress,
      warnOnNavigate,
    } = this.props;

    const currentIndex = steps.findIndex(s => s.type === currentPage);

    const forwardLabelFlow = (currentIndex < steps.length - 1) ? this.t(`AgentProfileSteps.${steps[currentIndex + 1].type}`) : undefined;
    const forwardLinkFlow = (currentIndex < steps.length - 1) ? steps[currentIndex + 1].type : undefined;

    const backLabelFlow = (currentIndex > 0) ? this.t(`AgentProfileSteps.${steps[currentIndex - 1].type}`) : undefined;
    const backLinkFlow = (currentIndex > 0) ? steps[currentIndex - 1].type : undefined;

    return {
      confirmHeading,
      confirmBody,
      forwardLabel: forwardLabel || forwardLabelFlow,
      forwardLink: forwardLink || forwardLinkFlow,
      backLabel: backLabel || backLabelFlow,
      backLink: backLink || backLinkFlow,
      isCallInProgress,
      warnOnNavigate,
    };
  }

  render() {
    const { currentPage } = this.props;
    const { status } = this.props.agentProfile;

    if (status === 'APPROVED') {
      return <div />;
    }

    const {
      confirmHeading,
      confirmBody,
      forwardLabel,
      forwardLink,
      backLabel,
      backLink,
      isCallInProgress,
      warnOnNavigate,
    } = this.getStepDefaults(currentPage);

    const confirm = (
      <div>
        <div>{confirmHeading}</div>
        {confirmBody}
      </div>
    );

    const appraiserNav = (
      <div>
        {warnOnNavigate && (
          <Row gutter={6}>
            <Col xs={12}>
              {backLink && (
                <Popconfirm
                  placement="topLeft"
                  title={confirm}
                  onConfirm={() => { this.props.onNavigate(backLink); }}
                  okText={this.t('Generic.yes')}
                  cancelText={this.t('Generic.no')}
                >
                  <Button
                    htmlType="button"
                    disabled={isCallInProgress}
                    className="ant-active-blue"
                  >
                    <Icon type="left-circle" theme="outlined" />
                    {backLabel || this.t('PartnerSetup.Wizard.buttons.back')}
                  </Button>
                </Popconfirm>
              )}
            </Col>
            <Col xs={12} style={{ textAlign: 'right' }}>
              {forwardLink && (
                <Popconfirm
                  placement="topRight"
                  title={confirm}
                  onConfirm={() => { this.props.onNavigate(forwardLink); }}
                  okText={this.t('Generic.yes')}
                  cancelText={this.t('Generic.no')}
                >
                  <Button
                    type="primary"
                    htmlType="button"
                    disabled={isCallInProgress}
                  >
                    {forwardLabel || this.t('PartnerSetup.Wizard.buttons.next')}
                    <Icon type="right-circle" theme="outlined" />
                  </Button>
                </Popconfirm>
              )}
            </Col>
          </Row>
        )}
        {!warnOnNavigate && (
          <Row gutter={6}>
            <Col xs={12}>
              {backLink && (
                <Button
                  htmlType="button"
                  onClick={() => { this.props.onNavigate(backLink); }}
                  disabled={isCallInProgress}
                  className="ant-active-blue"
                >
                  <Icon type="left-circle" theme="outlined" />
                  {backLabel || this.t('PartnerSetup.Wizard.buttons.back')}
                </Button>
              )}
            </Col>
            <Col xs={12} style={{ textAlign: 'right' }}>
              {forwardLink && (
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => { this.props.onNavigate(forwardLink); }}
                  disabled={isCallInProgress}
                >
                  {forwardLabel || this.t('PartnerSetup.Wizard.buttons.next')}
                  <Icon type="right-circle" theme="outlined" />
                </Button>
              )}
            </Col>
          </Row>
        )}
      </div>
    );

    const backOfficeNav = (
      <Row gutter={6}>
        <Col xs={24} className="align-right">
          <Button
            type="primary"
            htmlType="button"
            onClick={() => { this.props.onNavigate(null); }}
            disabled={isCallInProgress}
          >
            {this.t('Generic.save')}
          </Button>
        </Col>
      </Row>
    );

    return isBackOffice ? backOfficeNav : appraiserNav;
  }
}

WizardNav.propTypes = {
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  currentPage: PropTypes.string.isRequired,
  confirmHeading: PropTypes.string,
  confirmBody: PropTypes.string,
  forwardLabel: PropTypes.string,
  forwardLink: PropTypes.string,
  backLabel: PropTypes.string,
  backLink: PropTypes.string,
  isCallInProgress: PropTypes.bool.isRequired,
  onNavigate: PropTypes.func.isRequired,
  warnOnNavigate: PropTypes.bool,
};

WizardNav.defaultProps = {
  confirmHeading: '',
  confirmBody: '',
  forwardLabel: '',
  forwardLink: '',
  backLabel: '',
  backLink: '',
  warnOnNavigate: false,
};

export default WizardNav;
